<ng-container *ngIf="fileName == null">
  <div class="{{dragAreaClass}} file-display">
    <input type="file" class="file-input"
        [accept]="allowedFileType"
        [disabled]="isDisabled"
        (change)="onFileSelected($event.target.files)" #fileUpload>

  No file.

      <aims-common-button-mini
          style="margin-left: 5px;"
          title="Upload"
          aria-label="Upload"
          [disabled]="isDisabled"
          (click)="fileUpload.click()" >
        <mat-icon color="primary">attach_file</mat-icon>
      </aims-common-button-mini>

{{dragAreaLabel }} file here
  <span class="too-big" *ngIf="showTooBig">*file too big</span>
  </div>
</ng-container>

<ng-container *ngIf="fileName">
  <div class="file-display">
    <span>{{fileName}}</span>
    <ng-container >
      <aims-common-button-mini
          style="margin-left: 10px;"
          title="Delete"
          aria-label="Delete"
          (click)="fileDelete()"
      >
        <mat-icon color="warn">delete</mat-icon>
      </aims-common-button-mini>
    </ng-container>
  </div>
</ng-container>
